import { render, staticRenderFns } from "./section1.vue?vue&type=template&id=4a666719"
import script from "./section1.vue?vue&type=script&lang=js"
export * from "./section1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports